<template>
  <BlockUI :blocked="proc">
    <ol class="breadcrumb">
      <router-link to="/" class="breadcrumb-item"> Dashboard </router-link>
      <router-link to="/settledGames" class="breadcrumb-item">
        <span>Settled Matches</span>
      </router-link>
      <router-link to="/profitandloss" class="breadcrumb-item">
        <span> Profit & Loss </span>
      </router-link>
      <router-link to="/profitandloss" class="breadcrumb-item textdecorationnone">
        <span class="colorbase">{{ id1 }}</span>
      </router-link>
      <router-link to="/statement" class="breadcrumb-item">
        <span>My Stmt.</span>
      </router-link>
      <router-link to="/ledgers" class="breadcrumb-item">
        <span>Company Ledgers</span>
      </router-link>
      <router-link to="/collectionReport" class="breadcrumb-item">
        <span>Collection Report</span>
      </router-link>
      <router-link to="/liveGames" class="breadcrumb-item">
        <span>Live Matches</span>
      </router-link>
    </ol>
    <div class="row">
      <div class="col-xs-12">
        <router-link :to="'/betslips/' + id + '/' + id1 + '/' + sp" type="button" class="btn btn-sm btn-indigo marginright5">Bet Slips</router-link>
        <router-link :to="'/betslips2/' + id + '/' + id1 + '/' + sp" type="button" class="btn btn-sm btn-indigo marginright5">Bet Slips2</router-link>
        <router-link :to="'/sessionbetslips/' + id + '/' + id1 + '/' + sp" type="button" class="btn btn-sm btn-indigo marginright5" v-if="sp === 'Cricket'">Session Bet Slips</router-link>
        <button type="button" class="btn btn-sm btn-indigo marginright5">Live Report</button>
        <router-link :to="'/clientreport/' + id + '/' + id1 + '/' + sp" type="button" class="btn btn-sm marginright5" :class="{ 'btn-success': getrname === 'ClientReport', 'btn-indigo': getrname !== 'ClientReport' }">Client Report</router-link>
        <router-link :to="'/collectionreport1/' + id + '/' + id1 + '/' + sp" type="button" class="btn btn-sm marginright5" :class="{ 'btn-success': getrname === 'CollectionReport1', 'btn-indigo': getrname !== 'CollectionReport1' }">Collection Report</router-link>
        <router-link :to="'/companyreport/' + id + '/' + id1 + '/' + sp" type="button" class="btn btn-sm marginright5" :class="{ 'btn-success': getrname === 'CompanyReport', 'btn-indigo': getrname !== 'CompanyReport' }">Company Report</router-link>
        <router-link :to="'/sessionearningsreport/' + id + '/' + id1 + '/' + sp" type="button" class="btn btn-sm btn-indigo" v-if="sp === 'Cricket'">Session Earning Report</router-link>
      </div>
    </div>
    <div class="table-responsive" v-if="getrname === 'CompanyReport'">
      <table class="table table-bordered table-sm table-hover row col-12">
        <thead>
          <tr>
            <th colspan="1"></th>
            <th colspan="3">Plus / Minus</th>
            <th colspan="4">COMMISSION</th>
            <th colspan="11">OTHERS</th>
          </tr>
          <tr>
            <th>Client Name</th>
            <th class="text-end">Match Plus Minus</th>
            <th class="text-end">Session Plus Minus</th>
            <th class="text-end">Total</th>
            <th class="text-end">Match. Stake</th>
            <th class="text-end">Ses. Stake</th>
            <th class="text-end">Match Commission</th>
            <th class="text-end">Session Commission</th>
            <th class="text-end">Total Commission</th>
            <th class="text-end">System Plus/Minus</th>
            <th class="text-end">OTHERS</th>
            <th class="text-end">Final</th>
            <th class="text-end">% Share</th>
            <th class="text-end">My Share</th>
            <th class="text-end">% Company Share</th>
            <th class="text-end">Company Share</th>
            <th class="text-end">% Downline Share</th>
            <th class="text-end">Downline Share</th>
            <th>Downline</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="d in cbets" :key="d.Id">
            <td>
              {{ d.N }}<span v-if="d.Dn">&nbsp;({{ d.Dn }})</span>
            </td>
            <td class="text-end">
              <span v-if="d.Mpm !== 0">{{ d.Mpm.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-end">
              <span v-if="d.Spm !== 0">{{ d.Spm.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-end">
              <span v-if="d.Mtpm !== 0">{{ d.Mtpm.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-end">
              <span v-if="d.Ms !== 0">{{ d.Ms.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-end">
              <span v-if="d.Ss !== 0">{{ d.Ss.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-end">
              <span v-if="d.Mc !== 0">{{ d.Mc.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-end">
              <span v-if="d.Sc !== 0">{{ d.Sc.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-end">
              <span v-if="d.Tc !== 0">{{ d.Tc.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-end">
              <span v-if="d.Stpm !== 0">{{ d.Stpm.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-end">
              <span v-if="d.O !== 0">{{ d.O.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-end">
              <span v-if="d.F !== 0">{{ d.F.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-end">
              <span v-if="d.my !== 0">{{ d.my.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-end">
              <span v-if="d.M1 !== 0">{{ d.M1.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-end">
              <span v-if="d.myu !== 0">{{ d.myu.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-end">
              <span v-if="d.M2 !== 0">{{ d.M2.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-end">
              <span>{{ (100 - d.my - d.myu).toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-end">
              <span v-if="d.M3 !== 0">{{ d.M3.toLocaleString("en-IN") }}</span>
            </td>
            <td>{{ d.D }}</td>
          </tr>
          <tr>
            <td>Total</td>
            <td class="text-end">
              <span v-if="cbetstotal.Mpm !== 0">{{ cbetstotal.Mpm.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-end">
              <span v-if="cbetstotal.Spm !== 0">{{ cbetstotal.Spm.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-end">
              <span v-if="cbetstotal.Mtpm !== 0">{{ cbetstotal.Mtpm.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-end">
              <span v-if="cbetstotal.Ms !== 0">{{ cbetstotal.Ms.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-end">
              <span v-if="cbetstotal.Ss !== 0">{{ cbetstotal.Ss.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-end">
              <span v-if="cbetstotal.Mc !== 0">{{ cbetstotal.Mc.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-end">
              <span v-if="cbetstotal.Sc !== 0">{{ cbetstotal.Sc.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-end">
              <span v-if="cbetstotal.Tc !== 0">{{ cbetstotal.Tc.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-end">
              <span v-if="cbetstotal.Stpm !== 0">{{ cbetstotal.Stpm.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-end">
              <span v-if="cbetstotal.O !== 0">{{ cbetstotal.O.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-end">
              <span v-if="cbetstotal.F !== 0">{{ cbetstotal.F.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-end"></td>
            <td class="text-end">
              <span v-if="cbetstotal.M1 !== 0">{{ cbetstotal.M1.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-end"></td>
            <td class="text-end">
              <span v-if="cbetstotal.M2 !== 0">{{ cbetstotal.M2.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-end"></td>
            <td class="text-end">
              <span v-if="cbetstotal.M3 !== 0">{{ cbetstotal.M3.toLocaleString("en-IN") }}</span>
            </td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="row" v-if="getrname === 'CollectionReport1'">
      <div class="col-6">
        <table class="table table-bordered table-hover">
          <thead>
            <tr>
              <th colspan="2">PAYMENT RECEIVING FROM (Lena Hai)</th>
            </tr>
            <tr>
              <th>Client Name</th>
              <th class="text-end">Current Balance</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="d in settlingusers.comusersl" :key="d">
              <td>{{ d.N }}</td>
              <td class="text-end">{{ d.A.toLocaleString("en-IN") }}</td>
            </tr>
            <tr>
              <td>Total (Lena Hai)</td>
              <td class="text-end">{{ settlingusers.totall.toLocaleString("en-IN") }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col-6">
        <table class="table table-bordered table-hover">
          <thead>
            <tr>
              <th colspan="2">PAYMENT PAID TO (Dena Hai)</th>
            </tr>
            <tr>
              <th>Client Name</th>
              <th class="text-end">Current Balance</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="d in settlingusers.comusersr" :key="d">
              <td>{{ d.N }}</td>
              <td class="text-end">{{ d.A.toLocaleString("en-IN") }}</td>
            </tr>
            <tr>
              <td>Total (Dena Hai)</td>
              <td class="text-end">{{ settlingusers.totalr.toLocaleString("en-IN") }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="row">
        <div class="col-12">
          <table class="table table-bordered table-hover">
            <tbody>
              <tr>
                <td>Net (Lena Hai)</td>
                <td class="text-end">
                  {{ settlingusers.totall.toLocaleString("en-IN") }}
                </td>
              </tr>
              <tr>
                <td>Net (Dena Hai)</td>
                <td class="text-end">
                  {{ settlingusers.totalr.toLocaleString("en-IN") }}
                </td>
              </tr>
              <tr>
                <td>Net</td>
                <td class="text-end">
                  {{ (settlingusers.totall - settlingusers.totalr).toLocaleString("en-IN") }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="table-responsive" v-if="getrname === 'ClientReport'">
      <h2 v-if="clientreport.client.length > 0">Client</h2>
      <table class="table table-bordered table-sm table-hover row col-12" v-if="clientreport.client.length > 0">
        <thead>
          <tr>
            <th colspan="1"></th>
            <th colspan="3">Plus / Minus</th>
            <th colspan="4">COMMISSION</th>
            <th colspan="7">OTHERS</th>
          </tr>
          <tr>
            <th>Client Name</th>
            <th class="text-end">Match Plus Minus</th>
            <th class="text-end">Session Plus Minus</th>
            <th class="text-end">Total</th>
            <!-- <th class="text-end">Match. Stake</th>
            <th class="text-end">Ses. Stake</th> -->
            <th class="text-end">Match Commission</th>
            <th class="text-end">Session Commission</th>
            <th class="text-end">Total Commission</th>
            <th class="text-end">System Plus/Minus</th>
            <th class="text-end">OTHERS</th>
            <th class="text-end">Final</th>
            <th class="text-end">%</th>
            <th class="text-end">My Share</th>
            <th class="text-end">Agent Share</th>
            <th class="text-end">Agent Downline</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="d in clientreport.client" :key="d.N">
            <td>
              {{ d.N }}<span v-if="d.Dn">&nbsp;({{ d.Dn }})</span>
            </td>
            <td class="text-end">
              <span v-if="d.Mpm !== 0">{{ d.Mpm.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-end">
              <span v-if="d.Spm !== 0">{{ d.Spm.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-end">
              <span v-if="d.Mtpm !== 0">{{ d.Mtpm.toLocaleString("en-IN") }}</span>
            </td>
            <!-- <td class="text-end">
              <span v-if="d.Ms !== 0">{{ d.Ms.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-end">
              <span v-if="d.Ss !== 0">{{ d.Ss.toLocaleString("en-IN") }}</span>
            </td> -->
            <td class="text-end">
              <span v-if="d.Mc !== 0">{{ d.Mc.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-end">
              <span v-if="d.Sc !== 0">{{ d.Sc.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-end">
              <span v-if="d.Tc !== 0">{{ d.Tc.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-end">
              <span v-if="d.Stpm !== 0">{{ d.Stpm.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-end">
              <span v-if="d.O !== 0">{{ d.O.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-end">
              <span v-if="d.F !== 0">{{ d.F.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-end">
              <span v-if="d.S !== 0">{{ d.S.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-end">
              <span v-if="d.Cs !== 0">{{ d.Cs.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-end">
              <span v-if="d.Ap !== 0">{{ d.Ap.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-end">
              <span v-if="d.D !== 0">{{ d.D.toLocaleString("en-IN") }}</span>
            </td>
            <!-- <td class="text-end">
              <span v-if="d.M1 !== 0">{{ d.M1.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-end">
              <span v-if="d.M2 !== 0">{{ d.M2.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-end">
              <span v-if="d.M3 !== 0">{{ d.M3.toLocaleString("en-IN") }}</span>
            </td> -->
          </tr>
          <tr>
            <td>Total</td>
            <td class="text-end">
              <span v-if="clientreport.clienttotal.Mpm !== 0">{{ clientreport.clienttotal.Mpm.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-end">
              <span v-if="clientreport.clienttotal.Spm !== 0">{{ clientreport.clienttotal.Spm.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-end">
              <span v-if="clientreport.clienttotal.Mtpm !== 0">{{ clientreport.clienttotal.Mtpm.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-end">
              <span v-if="clientreport.clienttotal.Ms !== 0">{{ clientreport.clienttotal.Ms.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-end">
              <span v-if="clientreport.clienttotal.Ss !== 0">{{ clientreport.clienttotal.Ss.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-end">
              <span v-if="clientreport.clienttotal.Mc !== 0">{{ clientreport.clienttotal.Mc.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-end">
              <span v-if="clientreport.clienttotal.Sc !== 0">{{ clientreport.clienttotal.Sc.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-end">
              <span v-if="clientreport.clienttotal.Tc !== 0">{{ clientreport.clienttotal.Tc.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-end">
              <span v-if="clientreport.clienttotal.Stpm !== 0">{{ clientreport.clienttotal.Stpm.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-end">
              <span v-if="clientreport.clienttotal.O !== 0">{{ clientreport.clienttotal.O.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-end">
              <span v-if="clientreport.clienttotal.F !== 0">{{ clientreport.clienttotal.F.toLocaleString("en-IN") }}</span>
            </td>
            <td></td>
            <td class="text-end">
              <span v-if="clientreport.clienttotal.D !== 0">{{ clientreport.clienttotal.D.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-end">
              <span v-if="clientreport.clienttotal.Cs !== 0">{{ clientreport.clienttotal.Cs.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-end">
              <span v-if="clientreport.clienttotal.Ap !== 0">{{ clientreport.clienttotal.Ap.toLocaleString("en-IN") }}</span>
            </td>
            <!-- <td class="text-end">
              <span v-if="clientreport.clienttotal.M1 !== 0">{{ clientreport.clienttotal.M1.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-end">
              <span v-if="clientreport.clienttotal.M2 !== 0">{{ clientreport.clienttotal.M2.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-end">
              <span v-if="clientreport.clienttotal.M3 !== 0">{{ clientreport.clienttotal.M3.toLocaleString("en-IN") }}</span>
            </td> -->
            <td></td>
          </tr>
        </tbody>
      </table>
      <h2 v-if="clientreport.agent.length > 0">Agent</h2>
      <table class="table table-bordered table-sm table-hover" v-if="clientreport.agent.length > 0">
        <thead>
          <tr>
            <th colspan="1"></th>
            <th colspan="3">Plus / Minus</th>
            <th colspan="4">COMMISSION</th>
            <th colspan="7">OTHERS</th>
          </tr>
          <tr>
            <th>Client Name</th>
            <th class="text-end">Match Plus Minus</th>
            <th class="text-end">Session Plus Minus</th>
            <th class="text-end">Total</th>
            <!-- <th class="text-end">Match. Stake</th>
            <th class="text-end">Ses. Stake</th> -->
            <th class="text-end">Match Commission</th>
            <th class="text-end">Session Commission</th>
            <th class="text-end">Total Commission</th>
            <th class="text-end">System Plus/Minus</th>
            <th class="text-end">OTHERS</th>
            <th class="text-end">Final</th>
            <th class="text-end">%</th>
            <th class="text-end">My Share</th>
            <th class="text-end">Agent Share</th>
            <th class="text-end">Agent Downline</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="d in clientreport.agent" :key="d.N">
            <td>
              {{ d.N }}<span v-if="d.Dn">&nbsp;({{ d.Dn }})</span>
            </td>
            <td class="text-end">
              <span v-if="d.Mpm !== 0">{{ d.Mpm.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-end">
              <span v-if="d.Spm !== 0">{{ d.Spm.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-end">
              <span v-if="d.Mtpm !== 0">{{ d.Mtpm.toLocaleString("en-IN") }}</span>
            </td>
            <!-- <td class="text-end">
              <span v-if="d.Ms !== 0">{{ d.Ms.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-end">
              <span v-if="d.Ss !== 0">{{ d.Ss.toLocaleString("en-IN") }}</span>
            </td> -->
            <td class="text-end">
              <span v-if="d.Mc !== 0">{{ d.Mc.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-end">
              <span v-if="d.Sc !== 0">{{ d.Sc.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-end">
              <span v-if="d.Tc !== 0">{{ d.Tc.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-end">
              <span v-if="d.Stpm !== 0">{{ d.Stpm.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-end">
              <span v-if="d.O !== 0">{{ d.O.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-end">
              <span v-if="d.F !== 0">{{ d.F.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-end">
              <span v-if="d.S !== 0">{{ d.S.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-end">
              <span v-if="d.Cs !== 0">{{ d.Cs.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-end">
              <span v-if="d.Ap !== 0">{{ d.Ap.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-end">
              <span v-if="d.D !== 0">{{ d.D.toLocaleString("en-IN") }}</span>
            </td>
            <!-- <td class="text-end">
              <span v-if="d.M1 !== 0">{{ d.M1.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-end">
              <span v-if="d.M2 !== 0">{{ d.M2.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-end">
              <span v-if="d.M3 !== 0">{{ d.M3.toLocaleString("en-IN") }}</span>
            </td> -->
          </tr>
          <tr>
            <td>Total</td>
            <td class="text-end">
              <span v-if="clientreport.agenttotal.Mpm !== 0">{{ clientreport.agenttotal.Mpm.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-end">
              <span v-if="clientreport.agenttotal.Spm !== 0">{{ clientreport.agenttotal.Spm.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-end">
              <span v-if="clientreport.agenttotal.Mtpm !== 0">{{ clientreport.agenttotal.Mtpm.toLocaleString("en-IN") }}</span>
            </td>
            <!-- <td class="text-end">
              <span v-if="clientreport.agenttotal.Ms !== 0">{{ clientreport.agenttotal.Ms.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-end">
              <span v-if="clientreport.agenttotal.Ss !== 0">{{ clientreport.agenttotal.Ss.toLocaleString("en-IN") }}</span>
            </td> -->
            <td class="text-end">
              <span v-if="clientreport.agenttotal.Mc !== 0">{{ clientreport.agenttotal.Mc.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-end">
              <span v-if="clientreport.agenttotal.Sc !== 0">{{ clientreport.agenttotal.Sc.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-end">
              <span v-if="clientreport.agenttotal.Tc !== 0">{{ clientreport.agenttotal.Tc.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-end">
              <span v-if="clientreport.agenttotal.Stpm !== 0">{{ clientreport.agenttotal.Stpm.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-end">
              <span v-if="clientreport.agenttotal.O !== 0">{{ clientreport.agenttotal.O.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-end">
              <span v-if="clientreport.agenttotal.F !== 0">{{ clientreport.agenttotal.F.toLocaleString("en-IN") }}</span>
            </td>
            <!-- <td class="text-end">
              <span v-if="clientreport.agenttotal.M1 !== 0">{{ clientreport.agenttotal.M1.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-end">
              <span v-if="clientreport.agenttotal.M2 !== 0">{{ clientreport.agenttotal.M2.toLocaleString("en-IN") }}</span>
            </td>
            <td class="text-end">
              <span v-if="clientreport.agenttotal.M3 !== 0">{{ clientreport.agenttotal.M3.toLocaleString("en-IN") }}</span>
            </td> -->
            <td></td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="table-responsive" v-if="getrname === 'ClientReport'"></div>
  </BlockUI>
</template>

<script>
import $$vm from "@/data/index";
import BlockUI from "primevue/blockui";

export default {
  name: "CompanyReport",
  components: {
    BlockUI,
  },
  data() {
    return {
      id: "",
      id1: "",
      sp: "",
      proc: false,
      routename: "",
      cbets: [],
      downline: {},
      cbetstotal: { mpm: 0, F: 0, Mc: 0, Mpm: 0, Ms: 0, Mtpm: 0, O: 0, Sc: 0, Spm: 0, Ss: 0, Stpm: 0, Tc: 0, M1: 0, M2: 0, M3: 0 },
      settling: {},
      settlingusers: { comusersl: [], comusersr: [], totall: 0, totalr: 0 },
      clientreport: {
        agent: [],
        client: [],
        agenttotal: { mpm: 0, F: 0, Mc: 0, Mpm: 0, Ms: 0, Mtpm: 0, O: 0, Sc: 0, Spm: 0, Ss: 0, Stpm: 0, Tc: 0, M1: 0, M2: 0, M3: 0 },
        clienttotal: { mpm: 0, F: 0, Mc: 0, Mpm: 0, Ms: 0, Mtpm: 0, O: 0, Sc: 0, Spm: 0, Ss: 0, Stpm: 0, Tc: 0, M1: 0, M2: 0, M3: 0 },
      },
      calldata: false,
    };
  },
  mounted() {
    this.update();
    this.calldata = false;
  },
  computed: {
    getrname: function () {
      return this.routename;
    },
  },
  methods: {
    update: function () {
      var self = this;
      if ($$vm.cn) {
        if (self.$route.params.id !== undefined && self.$route.params.id !== self.id) {
          self.id = self.$route.params.id;
          self.calldata = true;
        }
        if (self.$route.params.id1 !== undefined && self.$route.params.id1 !== self.id1) {
          self.id1 = self.$route.params.id1;
          self.calldata = true;
        }
        if (self.$route.params.sp !== undefined && self.$route.params.sp !== self.sp) {
          self.sp = self.$route.params.sp;
          self.calldata = true;
        }
        if (self.$route.name !== undefined && self.$route.name !== self.routename) {
          self.routename = self.$route.name;
          self.calldata = true;
        }
        if (self.$route.name !== undefined && self.$route.fullpath !== self.fullpath) {
          self.fullpath = self.$route.fullpath;
          self.calldata = true;
        }
        if (self.calldata) {
          self.calldata = false;
          self.getd();
        }
      }
      setTimeout(function () {
        self.update();
      }, 1000);
    },
    getd: function () {
      var self = this;
      if ($$vm.cn) {
        self.proc = true;
        self.cbets = [];
        self.settling = {};
        self.settlingusers = { comusersl: [], comusersr: [], totall: 0, totalr: 0 };
        self.cbetstotal = { F: 0, Mc: 0, Mpm: 0, Ms: 0, Mtpm: 0, O: 0, Sc: 0, Spm: 0, Ss: 0, Stpm: 0, Tc: 0, M1: 0, M2: 0, M3: 0 };
        self.clientreport = {
          agent: [],
          client: [],
          agenttotal: { F: 0, Mc: 0, Mpm: 0, Ms: 0, Mtpm: 0, O: 0, Sc: 0, Spm: 0, Ss: 0, Stpm: 0, Tc: 0, Ap: 0, Cs: 0 },
          clienttotal: { F: 0, Mc: 0, Mpm: 0, Ms: 0, Mtpm: 0, O: 0, Sc: 0, Spm: 0, Ss: 0, Stpm: 0, Tc: 0, Ap: 0, Cs: 0 },
        };
        $$vm.c.invoke("companyreport", self.id).then(
          function (data) {
            self.proc = false;
            data = $$vm.decompress(data);
            self.downline = data.S;
            $.each(data.B, function (ii, jj) {
              if (jj["T"] !== 16) {
                self.clientreport.agent.push(jj);
              } else {
                self.clientreport.client.push(jj);
              }
              if (jj["Cs"] === 0) {
                self.settlingusers.comuserszero.push(jj);
              } else if (jj["Cs"] > 0) {
                jj["A"] = jj["Cs"];
                self.settlingusers.comusersl.push(jj);
                self.settlingusers.totall += jj["A"];
              } else {
                jj["A"] = -1 * jj["Cs"];
                self.settlingusers.comusersr.push(jj);
                self.settlingusers.totalr += jj["A"];
              }
            });
            // self.cbets = data.B;
            $.each(self.clientreport.agent, function (aaa, bbb) {
              self.clientreport.agenttotal.Tc += bbb["Tc"];
              self.clientreport.agenttotal.Stpm += bbb["Stpm"];
              self.clientreport.agenttotal.Spm += bbb["Spm"];
              self.clientreport.agenttotal.Sc += bbb["Sc"];
              self.clientreport.agenttotal.O += bbb["O"];
              self.clientreport.agenttotal.Mtpm += bbb["Mtpm"];
              self.clientreport.agenttotal.Mpm += bbb["Mpm"];
              self.clientreport.agenttotal.Mc += bbb["Mc"];
              self.clientreport.agenttotal.F += bbb["F"];
              self.clientreport.agenttotal.D += bbb["D"];
              self.clientreport.agenttotal.Cs += bbb["Cs"];
              self.clientreport.agenttotal.Ap += bbb["Ap"];
            });
            $.each(self.clientreport.client, function (aaa, bbb) {
              self.clientreport.clienttotal.Tc += bbb["Tc"];
              self.clientreport.clienttotal.Stpm += bbb["Stpm"];
              self.clientreport.clienttotal.Spm += bbb["Spm"];
              self.clientreport.clienttotal.Sc += bbb["Sc"];
              self.clientreport.clienttotal.O += bbb["O"];
              self.clientreport.clienttotal.Mtpm += bbb["Mtpm"];
              self.clientreport.clienttotal.Mpm += bbb["Mpm"];
              self.clientreport.clienttotal.Mc += bbb["Mc"];
              self.clientreport.clienttotal.F += bbb["F"];
              self.clientreport.clienttotal.D += bbb["D"];
              self.clientreport.clienttotal.Cs += bbb["Cs"];
              self.clientreport.clienttotal.Ap += bbb["Ap"];
            });
          },
          function (err) {
            self.proc = false;
          }
        );
      } else {
        setTimeout(function () {
          self.getd();
        }, 200);
      }
    },
  },
};
</script>

<style></style>
